import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit exemplar — the plain interior wall segment every other wall
// piece follows: it runs along the X axis through the tile centre, exactly
// one tile (1 m) long, 0.12 thick, 2.6 high, so consecutive wall tiles form
// a continuous wall and the consumer rotates in 90-degree steps to orient.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const wallPlain = defineModel({
  id: "wall-plain",
  batchId: "modern",
  name: "Wall",
  tags: ["modern", "interior", "structure", "wall"],
  summary: "A plain plastered interior wall segment, one tile long.",
  description:
    "The basic straight wall piece of the Modern Living kit: 1 m long, " +
    "0.12 m thick, 2.6 m high, running along X through the tile centre. " +
    "Chain tiles for longer walls; rotate 90 degrees to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.12), color: PLASTER, position: [0, 1.3, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.1, 0.15), color: BASEBOARD, position: [0, 0.05, 0] },
    ];
  },
  animations: [],
});
